module.exports = __webpack_public_path__ + "img/car-safety-bottom_ec-phev.5feb783b.png";